import React from 'react';
import EditorStrike from '@wix/da-ds/pkg/Icons/24x24/EditorStrike';
import { ButtonProps } from '../../menus/buttons/types';
import EditorUnderline from '@wix/da-ds/pkg/Icons/24x24/EditorUnderline';
import { useTranslation } from 'react-i18next';
import { isExtensionInstalled } from '../../utils/tiptap';
import EditorIconButtonWithContextMenu from '../_partials/EditorIconButtonWithContextMenu';
import { EditorContextMenuItem } from '../_partials/EditorIconButtonWithContextMenu/EditorIconButtonWithContextMenu';

const TextDecoration: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');

  const isUnderlineInstalled = isExtensionInstalled(editor, 'underline');
  const isStrikeThroughInstalled = isExtensionInstalled(
    editor,
    'strikethrough'
  );

  if (!isUnderlineInstalled && !isStrikeThroughInstalled) {
    return null;
  }

  const items = [] as EditorContextMenuItem[];
  if (isStrikeThroughInstalled) {
    items.push({
      featureId: "format:strike",
      label: t('button.textDecoration.strikethrough'),
      IconComponent: EditorStrike,
      isActive: editor.isActive('strike'),
      onClick: () => editor.chain().focus().toggleStrike().run(),
    });
  }
  if (isUnderlineInstalled) {
    items.push({
      featureId: "format:underline",
      label: t('button.textDecoration.underline'),
      IconComponent: EditorUnderline,
      isActive: editor.isActive('underline'),
      onClick: () => editor.chain().focus().toggleUnderline().run(),
    });
  }

  return (
    <EditorIconButtonWithContextMenu
      featureId="format:decoration"
      tooltipText={t('ext.deviation.toolbar.alignment')}
      aria-label={t('ext.deviation.toolbar.alignment')}
      icon={EditorStrike}
      items={items}
    />
  );
};
TextDecoration.displayName = 'TextDecoration';

export default TextDecoration;
